import React, { useEffect, useState } from 'react';
import RestaurantLayout from '../../components/Restaurant/RestaurantLayout';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Divider,
  Step,
  StepLabel,
  Stepper,
  TextField,
} from '@material-ui/core';
import { map, trim } from 'lodash';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import memberAPI from '../../middleware/memberAPI';
import { LIST_PAGE_COUNT, ProductPackageStatus } from '../../data/common';
import { alertError } from '../../Util/Util';
import TableEmpty from '../../components/TableEmpty';
import MemberCard from '../../components/MemberManagement/MemberCard';
import { Pagination } from '@material-ui/lab';
import TableLoading from '../../components/TableLoading';
import productPackageAPI from '../../middleware/productPackageAPI';
import ProductPackageCard from '../../components/ProductPackages/ProductPackageCard';
import PaperLinkScanner from '../../components/Bonus/PaperLinkScanner';
import { useHistory } from 'react-router';
import PermContactCalendarRoundedIcon from '@material-ui/icons/PermContactCalendarRounded';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    padding: theme.spacing(3),
    maxWidth: '500px',
    margin: theme.spacing(0, 'auto'),
    borderRadius: theme.spacing(0.5),
  },
  memberList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: theme.spacing(2),
  },
  pagination: {
    margin: 'auto',
  },
  stepTitle: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  stepTitleSubText: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
  stepBtns: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'space-evenly',
    margin: theme.spacing(2, 0, 0),
  },
  subTitle: {
    fontSize: '1.1rem',
    fontWeight: '600',
    margin: theme.spacing(1, 0),
    color: '#8b8b8b',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const STEPS = [
  {
    key: 'member',
    name: '會員',
  },
  {
    key: 'productPackage',
    name: '套券',
  },
  {
    key: 'scan',
    name: '掃描',
  },
];

const LinkBonusProductQRCode = () => {
  const classes = useStyles();
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const [nowStep, setNowStep] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [searchMemberValue, setSearchMemberValue] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [members, setMembers] = useState();
  const [isConsignment, setIsConsignment] = useState(false);
  const [selectedMember, setSelectedMember] = useState();
  const [productPackages, setProductPackages] = useState([]);
  const [selectedProductPackage, setSelectedProductPackage] = useState();

  useEffect(() => {
    setNowStep(STEPS[activeStep]);
  }, [activeStep]);

  useEffect(() => {
    if (nowStep && nowStep.key === 'member') {
      searchMember();
    }

    if (nowStep && nowStep.key === 'productPackage') {
      getProductPackages();
    }
  }, [page, nowStep]);

  const handleChangeSearchMemberValue = (e) => {
    setSearchMemberValue(trim(e.target.value));
  };

  const handleClickSearchMember = () => {
    if (page !== 1) {
      setPage(1);
    } else {
      searchMember();
    }
  };

  const searchMember = () => {
    if (trim(searchMemberValue) === '') {
      return false;
    }

    setIsLoading(true);

    memberAPI
      .getMemberList(page, LIST_PAGE_COUNT, 1, searchMemberValue)
      .then(
        (rs) => {
          setTotal(rs.totalCount);
          setMembers(rs.memberList);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const selectMember = (member) => {
    setSelectedMember(member);
  };

  const cancelMember = () => {
    setSelectedMember(undefined);
  };

  const handleClickNextStep = () => {
    setActiveStep(activeStep + 1);
  };

  const handleClickBackStep = () => {
    setActiveStep(activeStep - 1);

    if (nowStep && nowStep.key === 'productPackage') {
      setSelectedProductPackage(undefined);
    }
  };

  const handleClickDoneStep = () => {
    history.push('/bonus');
  };

  const getProductPackages = () => {
    setIsLoading(true);

    productPackageAPI
      .getProductPackages(1, 100000, { status: ProductPackageStatus.ALL })
      .then(
        (rs) => {
          setProductPackages(rs.productPackageList || []);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const selectProductPackage = (productPackage) => {
    setSelectedProductPackage(productPackage);
  };

  const cancelProductPackage = () => {
    setSelectedProductPackage(undefined);
  };

  const handleChangeIsConsignment = (checked) => {
    setIsConsignment(checked);
  };

  return (
    <RestaurantLayout showBackBtn hideLogo={nowStep && nowStep.key === 'scan'}>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {map(STEPS, (step) => (
            <Step key={step.key}>
              <StepLabel>{step.name}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {nowStep && nowStep.key === 'member' && (
          <div className={classes.stepBlock}>
            {!selectedMember && (
              <>
                <TextField
                  label="輸入會員姓名或手機搜尋"
                  variant="standard"
                  value={searchMemberValue}
                  onChange={handleChangeSearchMemberValue}
                  disabled={isLoading}
                />
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<SearchRoundedIcon />}
                  onClick={handleClickSearchMember}
                  disabled={isLoading || trim(searchMemberValue) === ''}>
                  搜尋
                </Button>

                {!isLoading && members && members.length <= 0 && (
                  <TableEmpty message="找不到會員" />
                )}

                {!isLoading && members && members.length > 0 && (
                  <div className={classes.memberList}>
                    {map(members, (member) => {
                      return (
                        <MemberCard
                          key={member.id}
                          member={member}
                          selectMember={selectMember}
                          cancelMember={cancelMember}
                        />
                      );
                    })}

                    <Pagination
                      classes={{
                        root: classes.pagination,
                      }}
                      disabled={isLoading}
                      count={Math.ceil(total / LIST_PAGE_COUNT)}
                      page={page}
                      shape="rounded"
                      color="primary"
                      onChange={(e, value) => {
                        setPage(value);
                      }}
                    />
                  </div>
                )}

                {isLoading && <TableLoading />}
              </>
            )}

            {selectedMember && (
              <MemberCard
                member={selectedMember}
                isSelected
                selectMember={selectMember}
                cancelMember={cancelMember}
              />
            )}
          </div>
        )}

        {nowStep && nowStep.key === 'productPackage' && (
          <div className={classes.stepBlock}>
            <div className={classes.stepTitle}>
              選擇購買所屬套券
              <div className={classes.stepTitleSubText}>非套券則不用選擇</div>
            </div>

            {isLoading && <TableLoading />}

            {!isLoading && productPackages && productPackages.length <= 0 && (
              <TableEmpty message="找不到套券" />
            )}

            {!isLoading && productPackages && productPackages.length > 0 && (
              <div
                className={classes.memberList}
                style={{ overflowY: 'auto', maxHeight: '400px' }}>
                {map(productPackages, (productPackage) => {
                  return (
                    <ProductPackageCard
                      key={productPackage.id}
                      productPackage={productPackage}
                      select={selectProductPackage}
                      cancel={cancelProductPackage}
                      selectedProductPackage={selectedProductPackage}
                    />
                  );
                })}
              </div>
            )}
          </div>
        )}

        {nowStep && nowStep.key === 'scan' && (
          <div>
            <PaperLinkScanner
              userId={selectedMember.id}
              productPackageId={
                selectedProductPackage ? selectedProductPackage.id : undefined
              }
              isConsignment={isConsignment}
              onIsConsignmentChange={handleChangeIsConsignment}
              isLoading={isLoading}
              onLoadingChange={setIsLoading}
            />

            <div className={classes.subTitle}>
              <PermContactCalendarRoundedIcon />
              歸戶資訊
            </div>

            <MemberCard member={selectedMember} isSelected />

            {selectedProductPackage && (
              <ProductPackageCard
                productPackage={selectedProductPackage}
                selectedProductPackage={selectedProductPackage}
              />
            )}
          </div>
        )}

        <div className={classes.stepBtns}>
          {nowStep && nowStep.key !== 'member' && (
            <Button
              variant="contained"
              color="default"
              fullWidth
              onClick={handleClickBackStep}
              disabled={isLoading}>
              返回
            </Button>
          )}

          {nowStep &&
            ['member', 'productPackage'].includes(nowStep.key) &&
            selectedMember && (
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleClickNextStep}
                disabled={isLoading}>
                下一步
              </Button>
            )}

          {nowStep && nowStep.key === 'scan' && (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleClickDoneStep}
              disabled={isLoading}>
              完成
            </Button>
          )}
        </div>
      </div>
    </RestaurantLayout>
  );
};

export default LinkBonusProductQRCode;
